'use strict';

import template from './login_history.html';

const controller = function ($scope, userModel) {
  'ngInject';
  var self = this;
  this.parser = {};
  require(['ua-parser-js'], function(UAParser) {
    self.parser = new UAParser();
  });

  userModel.getLoginHistory().then((history) => {
    self.history = history;
    for(var i = 0; self.history.length > i; i++){
      self.parser.setUA(self.history[i].user_agent);
      self.history[i].browser = self.parser.getBrowser();
    }
  });
};

const saLoginHistory = [
  function () {
    return {
      template: template,
      replace: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saLoginHistory;



// WEBPACK FOOTER //
// ./app/src/modules/login_history/login_history.component.js